import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container rounded shadow bg-white px-4 pb-5 pt-3" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "col-sm-6 mb-2" }
const _hoisted_5 = { class: "col-sm-6 mb-2" }
const _hoisted_6 = { class: "col-sm-6 mb-2" }
const _hoisted_7 = { class: "col-sm-6 mb-2" }
const _hoisted_8 = { class: "col-sm-6 mb-2" }
const _hoisted_9 = { class: "col-sm-6 mb-2" }
const _hoisted_10 = { class: "col-sm-6 mb-2" }
const _hoisted_11 = { class: "col-sm-6 mb-2" }
const _hoisted_12 = { class: "col-sm-6 mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JMCalendar = _resolveComponent("JMCalendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$route.params.id == undefined)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "Add Form"))
      : (_openBlock(), _createElementBlock("h2", _hoisted_3, "Edit Form")),
    _createElementVNode("form", {
      class: "row needs-validation",
      onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label" }, "Month", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "number",
          placeholder: " ",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.doc.month) = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.doc.month,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label" }, "Year", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "number",
          placeholder: " ",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.doc.year) = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.doc.year,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label" }, "Span", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.doc.span) = $event))
        }, null, 512), [
          [_vModelText, _ctx.doc.span]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label" }, "Side", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "text",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.doc.side) = $event))
        }, null, 512), [
          [_vModelText, _ctx.doc.side]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label" }, "Type", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "text",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.doc.type) = $event))
        }, null, 512), [
          [_vModelText, _ctx.doc.type]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label" }, "length", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "number",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.doc.length) = $event))
        }, null, 512), [
          [_vModelText, _ctx.doc.length]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label" }, "Rate", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "number",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.doc.rate) = $event))
        }, null, 512), [
          [_vModelText, _ctx.doc.rate]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label" }, "Amount", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "number",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.doc.qty) = $event))
        }, null, 512), [
          [_vModelText, _ctx.doc.qty]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_JMCalendar, {
          label: "Erection",
          modelValue: _ctx.doc.erection,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.doc.erection) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _cache[18] || (_cache[18] = _createStaticVNode("<div class=\"row g-3 d-flex justify-content-center\"><div class=\"col-5\"><button class=\"w-100 btn btn-secondary text-white btn-lg mt-4\">ย้อนกลับ</button></div><div class=\"col-5\"><button class=\"w-100 btn btn-primary btn-lg mt-4 text-white\" id=\"save\" type=\"submit\">บันทึก</button></div></div>", 1))
    ], 32)
  ]))
}